import styled from 'styled-components';

import {commonPalette} from 'styles/palette';

export const BackgroundCircle = styled.circle`
  fill: none;
  stroke: #c4c4c4;
`;

export const ForegroundCircle = styled.circle`
  fill: none;
  stroke: ${commonPalette.sgGreen};
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  transition: 0.2s stroke-dashoffset ease-out;
`;
